import { useEffect, useState, useRef, useCallback } from "react";
import { api } from "./api";

/**
 * Single global polling hook. Pulls /state every 2s. Components consume via context.
 */
export function usePlantState(intervalMs = 2000) {
  const [state, setState] = useState(null);
  const [error, setError] = useState(null);
  const mounted = useRef(true);

  const fetchOnce = useCallback(async () => {
    try {
      const s = await api.state();
      if (mounted.current) setState(s);
    } catch (e) {
      if (mounted.current) setError(e.message);
    }
  }, []);

  useEffect(() => {
    mounted.current = true;
    fetchOnce();
    const id = setInterval(fetchOnce, intervalMs);
    return () => { mounted.current = false; clearInterval(id); };
  }, [fetchOnce, intervalMs]);

  return { state, error, refresh: fetchOnce };
}

export function useResource(fn, deps = [], intervalMs = 4000) {
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    const run = async () => {
      try {
        const d = await fn();
        if (alive) setData(d);
      } catch { /* ignore */ }
    };
    run();
    const id = setInterval(run, intervalMs);
    return () => { alive = false; clearInterval(id); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return data;
}
